import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { hasLogbookEnabled } from '@BUP/services/BraveUp'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const LogbookRoute = ({ children }) => {
  const organization = useContext(OrganizationContext)

  if (!hasLogbookEnabled(organization)) return <Navigate to='/' />
  return children
}

export default LogbookRoute
